import { render, staticRenderFns } from "./PermissionRoleIndex.vue?vue&type=template&id=2840833e&scoped=true&"
import script from "./PermissionRoleIndex.vue?vue&type=script&lang=js&"
export * from "./PermissionRoleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840833e",
  null
  
)

export default component.exports